import { useMediaQueryContext } from '../contexts/system/MediaQuery.js';

var useScreenSize = function useScreenSize() {
  var mediaQuery = useMediaQueryContext();
  if (mediaQuery.xl) return 'xl';
  if (mediaQuery.l) return 'l';
  if (mediaQuery.m) return 'm';
  return 's';
};

export { useScreenSize as default };
//# sourceMappingURL=useScreenSize.js.map
